import type { Resource } from '~/assets/bindings'

export default (name: Ref<string>, fallback: number = 0) => {
  const page = useDocument()
  const db = useDatabase()
  const resources = inject<Ref<Record<string, Resource>>>('resources', ref({}))

  const fallbackRef = ref(fallback)

  return computed<number>({
    get: () => {
      if (name.value) {
        const resource = resources.value[name.value]
        return resource?.value ?? fallback
      } else {
        return fallbackRef.value
      }
    },
    set: (val: number) => {
      console.log('set', name.value)
      if (name.value) {
        db.value?.reducers.updateResource(page.value._id, name.value, val)
      } else {
        fallbackRef.value = val
      }
    },
  })
}
